import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.23336 9.12052V13.8872H6.70003V10.4205C6.70003 10.1907 6.79134 9.97022 6.95387 9.80769C7.1164 9.64516 7.33684 9.55385 7.5667 9.55385H8.43336C8.66322 9.55385 8.88366 9.64516 9.04619 9.80769C9.20872 9.97022 9.30003 10.1907 9.30003 10.4205V13.8872H12.7667V9.12052M1.5 8.25381L7.38698 2.36683C7.46746 2.28629 7.56303 2.22241 7.66821 2.17882C7.7734 2.13523 7.88614 2.11279 8 2.11279C8.11386 2.11279 8.2266 2.13523 8.33179 2.17882C8.43697 2.22241 8.53254 2.28629 8.61302 2.36683L14.5 8.25381",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHome;
